export class AssetAudit {

  auditId: number;
  createdDate: Date;
  assetId: number;
  userId: number;
  adminUserId: number;
  oldValue: string;
  newValue: string;
  notes: string;
  auditType: string;
  adminUserLogin: string;

  public static constructFromSearchListJson(objectListJson: any[]): AssetAudit[] {
    const searchList: AssetAudit[] = [];
    if (objectListJson) {
      for (const itemJson of objectListJson) {
        const auditItem: AssetAudit = AssetAudit.constructFromObjectJson(itemJson);
        searchList.push(auditItem);
      }
    }
    return searchList;
  }

  public static constructFromObjectJson(objectJson: any): AssetAudit {
    return Object.assign(new AssetAudit(), objectJson);
  }
}
